import { useMutation } from '@tanstack/react-query';

import { TypeRequestHeaders, axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

/** @category useWithdrawAccount */
export type TypeWithdrawAccountParams = {
  /** 로그인 아이디 */
  loginId: string;
  /** 비밀번호 */
  password: string;
};

/** @category useWithdrawAccount */
export type TypeWithdrawAccountResponse = {
  /** 계정 코드 */
  laborAccountId: number;
};

/**
 * @description 계정 탈퇴하기 api 요청에 사용되는 커스텀 훅
 */
export const useWithdrawAccount = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeWithdrawAccountParams & { headers?: TypeRequestHeaders }) => {
      const endpoint = '/labor-account';
      return axiosInstance.delete(endpoint, { data: params, headers: params.headers });
    },
  });

  const requestWithdrawAccount = async ({
    params,
    headers,
    onSuccess,
    onError,
  }: {
    params: TypeWithdrawAccountParams;
    headers?: TypeRequestHeaders;
    onSuccess?: (res: TypeWithdrawAccountResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync({ ...params, headers }), onSuccess, onError);
  };

  return requestWithdrawAccount;
};
